import './departmentDropdownDialog.scss';
import React, { useReducer, useRef, useState } from 'react';
import DListView, { IDListRef } from './components/@list/list';
import { EPlatformTravelType as TravelType, EPlatformSectionType as SectionType, DEPARTMENT_ACCESS } from '@umu/umu-types';
import { DialogReducer } from './dialogReducer';
import { DialogContext, initState } from './dialogContext';

interface IProps {
    departmentId: string; // 默认展示的部门id
    isRadio?: boolean; // 是否单选模式
    cleanSelected: number; // 外部清理已选标示，每次+1
    isAllowSelect?: boolean; // 是否展示全选
    isShowMember?: boolean; // 是否展示成员数量
    allSelectText?: string; // 全选展示文案
    defaultSelectedList?: string; // 默认选择的id，用,隔开。如“43,34"
    cbDo?: (data: any[]) => void; // 已选回调。
    access?: DEPARTMENT_ACCESS;
}

export default function DepartmentDropdownDialog(props: IProps) {
    const [cleanSelectedIndex, setCleanSelected] = useState(1);
    const [state, dispatch] = useReducer(DialogReducer, { ...initState });
    const refList = useRef<IDListRef>(null);
    const values = Object.values(state.selectedMap);
    const selectList: any[] = [];
    // let cleanSelectedIndex = 1;
    values.forEach((value) => {
        if (value.oriData) {
            selectList.push(value.oriData);
        }
    });
    if (props.cbDo) {
        props.cbDo(selectList);
    }
    // console.log('xxxxx0', props.defaultSelectedList );
    if (props.cleanSelected === cleanSelectedIndex) {
        setCleanSelected(props.cleanSelected + 1);
        // console.log('xxxxx1', props.cleanSelected, cleanSelectedIndex);
        if (refList && refList.current) {
            refList.current.cleanStateByParent();
        }
    }

    return (
        <DialogContext.Provider
            value={{
                state,
                dispatch,
            }}
        >
            <div className="department-dropdown-dialog">
                <DListView
                    type={TravelType.department}
                    section={SectionType.left}
                    departmentId={props.departmentId}
                    isRadio={props.isRadio}
                    ref={refList}
                    isAllowSelect={props.isAllowSelect}
                    isShowMember={props.isShowMember}
                    allSelectText={props.allSelectText}
                    defaultSelectedList={props.defaultSelectedList}
                    isFromDrop={true}
                    clsName="drop"
                    access={props.access}
                />
            </div>
        </DialogContext.Provider>
    );
}
